import React from 'react';

export type HoverImageProps = {
  src: string;
  hoverSrc: string;
  alt: string;
  hover?: boolean;
  disabled?: boolean;
  className?: string;
  style?: any;
  onClick?: React.MouseEventHandler;
};

export const HoverImage: React.FC<HoverImageProps> = ({
  src,
  hoverSrc,
  alt,
  hover,
  style,
  disabled,
  onClick,
  className,
}) => {
  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      if (!disabled) onClick && onClick(e);
    },
    [disabled, onClick]
  );

  const imageSrc = hover ? hoverSrc : src;

  return <img src={imageSrc} alt={alt} style={style} onClick={handleClick} className={className} />;
};
